/* 横スクロールする一覧（[data-scroll-fade]）に、次の3つを与える汎用ユーティリティ。
     ① 見切れフェード … スクロール位置を data-fade（none/start/end）に反映。CSS 側が mask-image で描く
     ② 送り矢印       … 同じ .scrollNav の中の [data-scroll-arrow] を制御し、カード1枚分ずつ送る
     ③ 掴んで動かす   … マウスのドラッグで横に流す。指・ペンには手を出さない（ブラウザ標準の横スクロールのまま）
   対象を増やすときは、一覧に data-scroll-fade を付け、親に .scrollNav と snippets/scroll-arrows.liquid を置く。 */
(function () {
  var DRAG_MIN = 5; // これ以上動かして初めてドラッグ扱い（クリックを邪魔しない）
  var SP = window.matchMedia('(max-width: 749px)'); // 現在の1枚に絞るのはこの幅だけ
  var lists = []; // 幅がスマホ／PCをまたいだときに付け直すため、初期化済みの一覧を控えておく

  function scopeOf(el) {
    return el.closest('.scrollNav');
  }

  function arrowOf(el, dir) {
    var scope = scopeOf(el);
    return scope ? scope.querySelector('[data-scroll-arrow="' + dir + '"]') : null;
  }

  function arrowBoxOf(el) {
    var scope = scopeOf(el);
    return scope ? scope.querySelector('[data-scroll-arrows]') : null;
  }

  /* 送り幅＝カード1枚分（先頭2枚の左端の差＝間隔込み）。1枚しか無ければ表示幅 */
  function stepWidth(el) {
    var items = el.children;
    if (items.length > 1) {
      var d = items[1].offsetLeft - items[0].offsetLeft;
      if (d > 0) return d;
    }
    return el.clientWidth;
  }

  function update(el) {
    var scrollable = el.scrollWidth > el.clientWidth + 1;
    var atStart = el.scrollLeft <= 1;
    var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    /* 🔑 真ん中は「ぼかし無し」が仕様（2026-08-15 ボス指示）。
       両端をぼかすと左右の見出し・本文が読めなくなるため、直すべき不具合ではない。
       ぼかすのは「左端なら右を」「右端なら左を」の2通りだけ。 */
    var fade = 'none';
    if (scrollable) {
      if (atStart && !atEnd) {
        fade = 'end';
      } else if (!atStart && atEnd) {
        fade = 'start';
      }
    }
    el.dataset.fade = fade;
    /* 掴める状態かどうかは data-fade では表せない（真ん中も none のため）＝別に持つ */
    if (scrollable) {
      el.dataset.scrollable = '';
    } else {
      delete el.dataset.scrollable;
    }

    updateCurrent(el, scrollable);

    var box = arrowBoxOf(el);
    if (box) box.hidden = !scrollable;
    var prev = arrowOf(el, 'prev');
    var next = arrowOf(el, 'next');
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  /* 中央に一番近い1枚へ data-scroll-current を付ける（動画を1本だけ再生させるために使う）。
     🔑 1枚に絞るのはスマホだけ（2026-09-03 ボス指示）。PC・タブレットはカードが3枚以上並ぶため、
     1枚に絞ると一度も再生されないカードが出る＝全員に付ける（＝見えているものはこれまでどおり動く）。
     全部収まっていて横に動かせない幅も、「現在の1枚」が成り立たないので同じく全員に付ける。
     🔑 中央だけで決めると先頭と末尾が一度も選ばれない
     （左端でも中央に近いのは2枚目、右端でも中央に近いのは後ろから2枚目のため）。
     そこで両端に着いているときだけ、先頭／末尾を現在の1枚とする。 */
  function updateCurrent(el, scrollable) {
    var kids = el.children;
    var single = scrollable && SP.matches;
    var current = null;
    if (single) {
      if (el.scrollLeft <= 1) {
        current = kids[0];
      } else if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 1) {
        current = kids[kids.length - 1];
      } else {
        var box = el.getBoundingClientRect();
        var center = box.left + box.width / 2;
        var best = Infinity;
        Array.prototype.forEach.call(kids, function (child) {
          var r = child.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - center);
          if (d < best) {
            best = d;
            current = child;
          }
        });
      }
    }
    Array.prototype.forEach.call(kids, function (child) {
      var isCurrent = !single || child === current;
      /* 同じ値でも書き直すと監視側が無駄に反応するので、変わるときだけ触る */
      if (isCurrent === child.hasAttribute('data-scroll-current')) return;
      if (isCurrent) child.setAttribute('data-scroll-current', '');
      else child.removeAttribute('data-scroll-current');
    });
  }

  function initArrows(el) {
    var prev = arrowOf(el, 'prev');
    var next = arrowOf(el, 'next');
    if (prev) {
      prev.addEventListener('click', function () {
        el.scrollBy({ left: -stepWidth(el), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        el.scrollBy({ left: stepWidth(el), behavior: 'smooth' });
      });
    }
  }

  /* 離した位置から一番近いカードへ、なめらかに寄せる。
     基準は CSS の scroll-padding-inline-start＝ブラウザの吸着と同じ位置に着地する。
     位置は getBoundingClientRect で測る（offsetLeft は position 付きの祖先が基準になり当てにならない） */
  function settle(el, done) {
    var pad = parseFloat(getComputedStyle(el).scrollPaddingInlineStart) || 0;
    var elLeft = el.getBoundingClientRect().left;
    var target = el.scrollLeft;
    var best = Infinity;
    Array.prototype.forEach.call(el.children, function (child) {
      var pos = el.scrollLeft + (child.getBoundingClientRect().left - elLeft) - pad;
      var d = Math.abs(pos - el.scrollLeft);
      if (d < best) {
        best = d;
        target = pos;
      }
    });
    target = Math.max(0, Math.min(target, el.scrollWidth - el.clientWidth));
    if (Math.abs(target - el.scrollLeft) < 1) {
      done();
      return;
    }
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      el.removeEventListener('scrollend', finish);
      done();
    }
    el.addEventListener('scrollend', finish);
    setTimeout(finish, 700); // scrollend 非対応ブラウザ・途中で止まった場合の保険
    el.scrollTo({ left: target, behavior: 'smooth' });
  }

  function initDrag(el) {
    var active = false;
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var snap = '';

    function swallowClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    function restoreSnap() {
      if (snap) {
        el.style.scrollSnapType = snap;
      } else {
        el.style.removeProperty('scroll-snap-type');
      }
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (el.scrollWidth <= el.clientWidth + 1) return;
      active = true;
      dragging = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_MIN) return;
        dragging = true;
        /* 掴んでいる間だけスナップを切る（付けたままだと1枚ずつ吸い付いてガタつく） */
        snap = el.style.scrollSnapType;
        el.style.scrollSnapType = 'none';
        el.classList.add('isGrabbing');
        /* 枠の外へ出ても追い続ける。合成イベントでは掴めないので失敗は握りつぶす */
        try { el.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
      el.scrollLeft = startLeft - dx;
    });

    function release() {
      if (!active) return;
      active = false;
      if (!dragging) return;
      dragging = false;
      el.classList.remove('isGrabbing');
      /* 🔑 スナップを戻すだけだと、ブラウザが一番近いカードへ《瞬間移動》させる（実測で最大162px飛ぶ）。
         自分でなめらかに寄せてから戻す＝止まる位置は同じで、動きだけが滑らかになる */
      settle(el, restoreSnap);
      /* 動かした直後のクリック1回だけ打ち消す（カード全体がリンクの箇所で誤爆させない） */
      el.addEventListener('click', swallowClick, true);
      setTimeout(function () {
        el.removeEventListener('click', swallowClick, true);
      }, 0);
    }

    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);
    /* 🚨 画像やリンクを掴むとブラウザ標準の「画像/リンクのドラッグ」が始まり、
       以降の pointermove がページに届かなくなる＝掴んで動かせない。
       CSS の -webkit-user-drag: none と二段構えで止める（Firefox はこちらが効く） */
    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initEl(el) {
    if (el.dataset.scrollFadeInit) return;
    el.dataset.scrollFadeInit = '1';
    lists.push(el);
    el.addEventListener('scroll', function () { update(el); }, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () { update(el); });
      ro.observe(el);
      Array.prototype.forEach.call(el.children, function (child) { ro.observe(child); });
    }
    initArrows(el);
    initDrag(el);
    update(el);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-scroll-fade]').forEach(initEl);
  }

  SP.addEventListener('change', function () {
    lists = lists.filter(function (el) { return el.isConnected; });
    lists.forEach(function (el) { update(el); });
  });

  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }
})();
